import { CampaignStage, SPECIAL_CHARACTERS } from '@urbanx/agx-ui-components';
import { UploadedDocumentDocumentType } from '@urbanx/agx.campaigns.client';

export const LISTING_DOCUMENT_TYPES: UploadedDocumentDocumentType[] = [
  UploadedDocumentDocumentType.ComparativeMarketAnalysis,
  UploadedDocumentDocumentType.MarketingAgreement,
  UploadedDocumentDocumentType.TitleSearch,
  UploadedDocumentDocumentType.PoolCertificate,
  UploadedDocumentDocumentType.NoPoolCertificate,
  UploadedDocumentDocumentType.ProofOfIdentity,
  UploadedDocumentDocumentType.MaterialFact,
  UploadedDocumentDocumentType.PowerOfAttorney,
  UploadedDocumentDocumentType.Miscellaneous,
  UploadedDocumentDocumentType.AgencyAgreement,
  UploadedDocumentDocumentType.SellerDisclosure,
  UploadedDocumentDocumentType.SurveyPlan,
  UploadedDocumentDocumentType.CommunityManagementStatement,
  UploadedDocumentDocumentType.BodyCorporateCertificate,
];

export const getCampaignStageLabel = (stage: unknown) =>
  CampaignStage[stage as keyof typeof CampaignStage]?.split(
    SPECIAL_CHARACTERS.BULLET
  )[1] ?? '';
